import { FiCheck } from "react-icons/fi";
import styled from "styled-components";

import Dropdown from "../../common/DropdownNew";
import FlexBox from "../../common/FlexBox";
import { H4 } from "../../common/Headings";
import { MOSS_GREEN_800 } from "../../common/colors";

const SummaryTypeDropdownWrapper = styled(FlexBox)`
  flex: 1;
  min-width: 16rem;
  max-width: 16rem;
`;

const ActiveBadge = styled(FlexBox)`
  align-items: center;
  gap: 0.25rem;
  color: ${MOSS_GREEN_800};
  font-size: 0.875rem;
  font-weight: 600;
`;

const SummaryTypeSelector = ({
  summaryTypeOptions,
  setSummaryType,
  hasActiveCustomization,
}) => (
  <FlexBox align="center" columnGap="1rem" padding="1.5rem">
    <H4 bold>Customise Summary for:</H4>
    <SummaryTypeDropdownWrapper>
      <Dropdown options={summaryTypeOptions} onSelectOption={setSummaryType} />
    </SummaryTypeDropdownWrapper>
    {hasActiveCustomization && (
      <ActiveBadge>
        <FiCheck size={16} />
        Active
      </ActiveBadge>
    )}
  </FlexBox>
);

export default SummaryTypeSelector;
